import gql from "graphql-tag";
import {ComplianceRuleFragment} from "../../../../Queries/Veriflyt";

export const QUERY_CUSTOMER_COMPLIANCE_RULES = gql`
    query ComplianceRulesPage_ComplianceRulesQuery(
        $limit: Int
        $skip: Int
        $bookmark: String
        $search: CustomerComplianceRulesSearchInput
    ){
        CustomerComplianceRules(limit: $limit, bookmark: $bookmark, skip: $skip, search: $search) {
            docs {
                ... on ComplianceRule {
                    ...ComplianceRuleFragment
                }
            }
            bookmark
        }
    }
    ${ComplianceRuleFragment}
`
export const MUTATION_SET_COMPLIANCE_RULE = gql`
    mutation ComplianceRulesPage_SetComplianceRule(
        $payload: ComplianceRulePayloadInput!
    ){
        SetComplianceRule(
            payload: $payload
        ){
            ...ComplianceRuleFragment
        }
    }
    ${ComplianceRuleFragment}
`

export const MUTATION_DELETE_COMPLIANCE_RULE = gql`
    mutation ComplianceRulesPage_DeleteComplianceRule(
        $id: ID!
        $tpID: ID!
    ){
        DeleteComplianceRule(
            ruleID: $id
            tpID: $tpID
        )
    }
`